/**
 * デザイントークン定義
 * アプリケーション全体で使用するデザインシステムの基盤となる定数
 *
 * このファイルはバレルエクスポートとして機能し、すべてのデザイントークンを
 * 単一のエントリーポイントから利用可能にします。
 *
 * @example
 * ```typescript
 * // 個別のトークンをインポート
 * import { COLORS, TYPOGRAPHY } from '@src/constants/design-tokens';
 *
 * // 統合オブジェクトをインポート
 * import { DESIGN_TOKENS } from '@src/constants/design-tokens';
 * ```
 */

// 各カテゴリからエクスポート
export { COLORS } from './colors';
export { ANIMATION, SHADOWS } from './effects';
export {
  FOCUS_MODE_BACKGROUNDS,
  FOCUS_MODE_BORDERS,
  FOCUS_MODE_BUTTON_BACKGROUNDS,
  FOCUS_MODE_COLORS,
  FOCUS_MODE_GRADIENTS,
  FOCUS_MODE_SHADOWS,
  getFocusModeValue,
} from './focus-mode';

// 個別インポートして統合オブジェクトを作成
import { COLORS } from './colors';
import { ANIMATION, GRADIENTS, SHADOWS } from './effects';
import { LAYOUT } from './layout';
import { BORDER_RADIUS, BREAKPOINTS, SPACING } from './spacing';
import { TYPOGRAPHY } from './typography';

/**
 * デザイントークンの統合エクスポート
 * すべてのデザイントークンを含む単一のオブジェクト
 */
export const DESIGN_TOKENS = {
  colors: COLORS,
  spacing: SPACING,
  breakpoints: BREAKPOINTS,
  typography: TYPOGRAPHY,
  borderRadius: BORDER_RADIUS,
  shadows: SHADOWS,
  gradients: GRADIENTS,
  layout: LAYOUT,
  animation: ANIMATION,
} as const;
